import React from "react";

interface TurboLoaderProps {
  /** Progress value from 0 to 100 */
  progress: number;
  /** Whether the loader is visible */
  visible: boolean;
  /** Color class (without 'bg-' prefix) */
  color?: string;
}

/**
 * A thin progress bar fixed to the top of the viewport.
 * Mimics Tabler's turbo-loader style for page loading feedback.
 */
export const TurboLoader: React.FC<TurboLoaderProps> = ({
  progress,
  visible,
  color = "primary",
}) => {
  return (
    <div
      className="turbo-loader"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        opacity: visible ? 1 : 0,
        transition: "opacity 0.2s ease",
        pointerEvents: "none",
      }}
    >
      <div
        className={`progress-bar bg-${color}`}
        role="progressbar"
        style={{
          height: "3px",
          width: `${progress}%`,
          transition: "width 0.15s ease",
        }}
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`${progress}% Complete`}
      />
    </div>
  );
};
